import React, { useEffect, useState } from "react";
import {
  IonContent,
  IonPage,
} from "@ionic/react";
import "./Landing.css";
import { useHistory, useLocation, useParams } from "react-router";
import { authActions } from './../../store/auth'
import { useDispatch } from 'react-redux'
import { CapacitorHttp } from "@capacitor/core";
import { get, set, clear } from "../../storage/storage";
import { isPlatform } from "@ionic/react";
import { getScannedCampaigns, storeScannedCampaign } from "../../common/common";

interface LandingConsumerProps {
  alreadyLoggedIn?: boolean;
}

const LandingConsumer: React.FC<LandingConsumerProps> = ({ alreadyLoggedIn }) => {
  const [loading, setLoading] = useState(true);
  const [alreadyScanned, setAlreadyScanned] = useState(false);
  const url_params: any = useParams();
  const qrCode = url_params?.qr_code;
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  // Admin preview: /qr/:qr_code?isAdmin=1 is opened by the admin booking page ("QR Code Active" phone popup).
  // The campaign is resolved and loaded as usual, but no scan is recorded (API skips tracking) and the
  // local "already scanned" bookkeeping is neither checked nor updated.
  const isAdminPreview = new URLSearchParams(location.search).get('isAdmin') === '1';

  const checkQRCode = async () => {


    if (typeof qrCode != 'undefined') {

      let res = await getQrCodeInfo();

      if (res.data?.success) {
        // Determine the identifier to track: either campaign ID or event ID
        const eventQrId = res.data?.data?.eventQrId;
        const eventId = res.data?.data?.ue_id;
        
        let trackingId;
        if (eventQrId && eventQrId !== '0' && eventQrId !== 0) {
          // It's a QR campaign - track by campaign ID
          trackingId = `campaign_${eventQrId}`;
        } else if (eventId) {
          // It's an individual event - track by event ID
          trackingId = `event_${eventId}`;
        }
        
        // Check if user has already scanned this QR campaign/event
        const allowMultipleScans = res.data?.data?.allowMultipleScans === true;
        if (trackingId && !allowMultipleScans && !isAdminPreview && hasScannedCampaign(trackingId) ) {
          setAlreadyScanned(true);
          setLoading(false);
          return;
        }

        // If user is logged in but scanning a different campaign, log out and reload
        // so they can access the new campaign's signup flow
        if (alreadyLoggedIn && res.data?.data?.has_active_event) {
          await clear();
          localStorage.removeItem('qrInfo');
          window.location.href = `/qr/${qrCode}${isAdminPreview ? '?isAdmin=1' : ''}`;
          return;
        }

        // Store the scanned campaign/event with its UUID
        // For QR campaigns with signup pages, defer storing until after successful signup (so users can re-scan if page fails)
        const signupQrIds = ['3', '4', '6', '9', '13', '14', '15', '16', '17', '19', '27'];
        if (trackingId && !signupQrIds.includes(eventQrId) && !isAdminPreview) {
          await getUUID(); // ensure UUID is created before storing
          storeScannedCampaign(trackingId, eventId, qrCode);
        }

        if (res.data?.data?.redirectTo) {
          if(res.data?.data?.redirectToIOS && isPlatform('ios')) {
            window.location.href = res.data?.data?.redirectToIOS;
            return;
          }
          window.location.href = res.data?.data?.redirectTo;
          return;
        }

        if (res.data?.data?.has_active_event) {
          localStorage.setItem('qrInfo', JSON.stringify({ ...res.data?.data, isAdmin: isAdminPreview }));

          if (res.data?.data?.theme == 'azlottery1') {
            history.push('/Signup_azlottery1');
            return;
          }

          if (res.data?.data?.theme == 'sparklingice1') {
            history.push('/Signup_sparklingice1');
            return;
          }
          if (res.data?.data?.theme == 'img__goldsgym1.png') {
            history.push('/Signup_goldsgym1');
            return;
          }

          if (res.data?.data?.eventQrId == '3') {
            history.push('/Signup_Popwell');
            return;
          }
          if (res.data?.data?.eventQrId == '4') {
            history.push('/Signup_WIP');
            return;
          }
          if (res.data?.data?.eventQrId == '6') {
            history.push('/Signup_Slice');
            return;
          }
          if (res.data?.data?.eventQrId == '9') {
            history.push('/QR9KoalaSignup');
            return;
          }
          if (res.data?.data?.eventQrId == '13') {
            history.push('/QR13RaceTrackSignup');
            return;
          }

          if (res.data?.data?.eventQrId == '14') {
            history.push('/QR14BeachLeashSignup');
            return;
          }

          if (res.data?.data?.eventQrId == '15') {
            history.push('/QR15TeamSnapSignup');
            return;
          }

          if (res.data?.data?.eventQrId == '16') {
            history.push('/QR16VitaCocoSignup');
            return;
          }

          if (res.data?.data?.eventQrId == '17') {
            history.push('/QR17ChobaniLanding');
            return;
          }

          if (res.data?.data?.eventQrId == '19') {
            history.push('/QR19Signup');
            return;
          }

          if (res.data?.data?.eventQrId == '27') {
            history.push('/QR27PUSHSignup');
            return;
          }
          
          history.push('/Signup');
          return;
        } else {
          window.location.href = 'https://pushmodels.com/'+res.data?.data?.model_site_url;
          return;
        }
      }
    }

    setLoading(false);
  }

  const generateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  }

  const hasScannedCampaign = (qrCampaignId: string) => {
    const scannedCampaigns = getScannedCampaigns();
    return scannedCampaigns.some((campaign: any) => campaign.qrCampaignId === qrCampaignId);
  };

  const getUUID = async () => {
    let uuid = localStorage.getItem('uuid');
    if (!uuid) {
      let uuidgen = generateUUID();
      localStorage.setItem('uuid',uuidgen);
      return uuidgen;
    }
    return uuid;
  }

  const getQrCodeInfo = async () => {
    let uuid = await getUUID();
    const scannedCampaigns = getScannedCampaigns();
    
    // Extract just the IDs (with prefixes) and join with comma separator
    const scannedCampaignIds = scannedCampaigns.map((campaign: any) => campaign.qrCampaignId).join(',');
    
    // isAdmin=1 tells the API to resolve the campaign without recording a scan
    let config: any = {
      url: encodeURI(
        `${process.env.REACT_APP_HP_API_URL}/users/qrCodeInfo?qrCode=${qrCode}&uuid=${uuid}&scannedCampaigns=${scannedCampaignIds}${isAdminPreview ? '&isAdmin=1' : ''}`
      ),
      headers: {
        "Content-Type": "application/json",
      },
    };

    console.log(config);

    let qrCodeInfoRes = await CapacitorHttp.get(config);
    return qrCodeInfoRes;
  }

  useEffect(() => {
    (async () =>  {
      await checkQRCode();
    })();
    
  }, []);

  return (
    <>
      <IonPage>
        <IonContent scroll-y="false">
          <div className="landing__container">
            <div className="landing__container-inner-shadow"></div>
            <div style={{height: '100%', display: 'flex', flexDirection:'column', alignItems: 'center', justifyContent: 'center'}}>
              {!loading && <>
              <img style={{width: '80%', maxWidth: '600px'}} src="/images/push-pulse-logo-01.png" />
              {alreadyLoggedIn && <div style={{padding: '20px', textAlign: 'center', color: '#FE6102', fontSize: '18px', fontWeight: 'bold', marginTop: '20px'}}>You have accessed this campaign in the last 24 hours.</div>}
              {alreadyScanned && <div style={{padding: '20px', textAlign: 'center', color: '#FE6102', fontSize: '18px', fontWeight: 'bold', marginTop: '20px'}}>You have already attended this Campaign.</div>}
              </>}
            </div>
          </div>
        </IonContent>
      </IonPage>
    </>
  );
};

export default LandingConsumer;
